export const next14thDay = new Date(Date.now() + 14 * 24 * 60 * 60 * 1000);
